import { jsx as _jsx } from "react/jsx-runtime";
import PIOversightSummaryFooter from '../../pages/participant_details/components/pi_oversight_summary_footer.component';
export const usePIOversightFooter = () => {
    const hasReviewableData = (reviewBundle) => {
        if (!reviewBundle) {
            return false;
        }
        const responses = reviewBundle?.responses ?? [];
        const dcrItems = reviewBundle?.dcrItems ?? [];
        const visitEvents = reviewBundle?.visitEvents ?? [];
        return responses.length > 0 || dcrItems.length > 0 || visitEvents.length > 0;
    };
    const renderPIOversightFooter = (reviewBundle, onReviewAndSignClick) => {
        if (!hasReviewableData(reviewBundle)) {
            return null;
        }
        return _jsx(PIOversightSummaryFooter, { onReviewAndSignClick: onReviewAndSignClick });
    };
    return {
        hasReviewableData,
        renderPIOversightFooter,
    };
};
